import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submitBtn"];

  onAcceptTermsChanged(e) {
    this.toggleSubmit(e.target.checked);
  }

  toggleSubmit(enabled) {
    this.submitBtnTargets.forEach(btn => btn.disabled = !enabled);
  }
}
